import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { mountCommandPalette } from './components/CommandPalette';
import './glass-all.css';
import { mountStaffHistory } from './components/StaffHistory';
import { mountShiftLock } from './components/ShiftLock';
import { mountUpdateBanner } from './components/UpdateBanner';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Offline support: lets the POS open without internet (production build only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}

// Scrolling must never change a number box: release focus before the wheel can alter it
document.addEventListener('wheel', (e) => {
  const el = document.activeElement;
  if (el && el.type === 'number' && (el === e.target || el.contains(e.target))) el.blur();
}, { passive: true, capture: true });

reportWebVitals();

mountCommandPalette();

mountStaffHistory();

mountShiftLock();

mountUpdateBanner();
